"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Info } from "lucide-react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { formatCurrency } from "@/helpers/format-currency";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
export interface HiddenPriceInfoProps {
  /** Text next to the info icon (default: "Price on Request") */
  text?: React.ReactNode;
  /** Title inside hover card */
  title?: string;
  /** Message inside hover card */
  message?: string;
  /** Optional callback when user clicks enquire */
  onEnquire?: () => void;
  /** Text for the enquire button */
  enquireButtonText?: string;
  /** Show only the icon without text */
  iconOnly?: boolean;
  /** Custom class for the trigger button */
  className?: string;
  /** Side where hovercard popup appears */
  side?: "top" | "bottom" | "left" | "right";
  /** Alignment of hovercard popup */
  align?: "start" | "center" | "end";
}
export const HiddenPriceInfo = t0 => {
  const $ = _c(30);
  const {
    text: t1,
    title: t2,
    message: t3,
    onEnquire,
    enquireButtonText: t4,
    iconOnly: t5,
    className,
    side: t6,
    align: t7
  } = t0;
  const text = t1 === undefined ? "Price on Request" : t1;
  const title = t2 === undefined ? "Direct Enrolment Unavailable" : t2;
  const message = t3 === undefined ? "This course is not available for direct enrolment. You can enquire for this price and dates." : t3;
  const enquireButtonText = t4 === undefined ? "Enquire Now" : t4;
  const iconOnly = t5 === undefined ? false : t5;
  const side = t6 === undefined ? "top" : t6;
  const align = t7 === undefined ? "end" : t7;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <button type="button" />;
    $[0] = t8;
  } else {
    t8 = $[0];
  }
  const t9 = iconOnly && "p-1 rounded-full";
  let t10;
  if ($[1] !== className || $[2] !== t9) {
    t10 = cn("inline-flex cursor-pointer items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-xs font-semibold text-slate-700 transition-colors hover:border-primary/40 hover:bg-slate-100 hover:text-primary dark:border-slate-800 dark:bg-slate-900/60 dark:text-slate-300 dark:hover:border-primary/40 dark:hover:bg-slate-900 dark:hover:text-primary", t9, className);
    $[1] = className;
    $[2] = t9;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  let t11;
  if ($[4] !== iconOnly || $[5] !== text) {
    t11 = !iconOnly && <span>{text}</span>;
    $[4] = iconOnly;
    $[5] = text;
    $[6] = t11;
  } else {
    t11 = $[6];
  }
  let t12;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Info className="h-3.5 w-3.5 shrink-0 text-primary" />;
    $[7] = t12;
  } else {
    t12 = $[7];
  }
  let t13;
  if ($[8] !== t10 || $[9] !== t11) {
    t13 = <HoverCardTrigger render={t8} delay={100} closeDelay={150} className={t10}>{t11}{t12}</HoverCardTrigger>;
    $[8] = t10;
    $[9] = t11;
    $[10] = t13;
  } else {
    t13 = $[10];
  }
  let t14;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary"><Info className="h-4 w-4" /></div>;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  let t15;
  if ($[12] !== title) {
    t15 = title && <h5 className="text-xs font-bold leading-tight text-foreground">{title}</h5>;
    $[12] = title;
    $[13] = t15;
  } else {
    t15 = $[13];
  }
  let t16;
  if ($[14] !== message) {
    t16 = <p className="text-xs leading-relaxed text-muted-foreground">{message}</p>;
    $[14] = message;
    $[15] = t16;
  } else {
    t16 = $[15];
  }
  let t17;
  if ($[16] !== enquireButtonText || $[17] !== onEnquire) {
    t17 = onEnquire && <div className="pt-2"><Button type="button" size="sm" className="h-7 px-3 text-xs font-semibold" onClick={e => {
        e.stopPropagation();
        onEnquire();
      }}>{enquireButtonText}</Button></div>;
    $[16] = enquireButtonText;
    $[17] = onEnquire;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  let t18;
  if ($[19] !== t15 || $[20] !== t16 || $[21] !== t17) {
    t18 = <div className="flex items-start gap-2.5">{t14}<div className="space-y-1 text-left">{t15}{t16}{t17}</div></div>;
    $[19] = t15;
    $[20] = t16;
    $[21] = t17;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== align || $[24] !== side || $[25] !== t18) {
    t19 = <HoverCardContent side={side} align={align} sideOffset={6} className="w-72 rounded-xl border border-border/80 bg-popover p-3.5 text-popover-foreground shadow-lg">{t18}</HoverCardContent>;
    $[23] = align;
    $[24] = side;
    $[25] = t18;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== t13 || $[28] !== t19) {
    t20 = <HoverCard>{t13}{t19}</HoverCard>;
    $[27] = t13;
    $[28] = t19;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  return t20;
};
export interface CoursePriceProps {
  /** The numerical selling price */
  price?: number | null;
  /** Currency code, e.g. "USD", "INR" */
  currency?: string | null;
  /** Explicit flag to hide price */
  isPriceHidden?: boolean;
  /** Array of service flags, e.g. ["HIDE_PRICE_ON_WEBSITE"] */
  serviceFlags?: string[];
  /** Label on the left. Set to false to hide. Defaults to "Course Fee" */
  label?: React.ReactNode;
  /** Text to show in place of price when hidden. Defaults to "Price on Request" */
  hiddenPriceText?: string;
  /** Tooltip/hover card message */
  infoText?: string;
  /** Tooltip/hover card title */
  infoTitle?: string;
  /** Callback triggered when user clicks enquire in the hover card */
  onEnquire?: () => void;
  /** Custom class for the wrapper container */
  className?: string;
  /** Custom class for the label */
  labelClassName?: string;
  /** Custom class for the price value */
  priceClassName?: string;
  /** If true, renders only the price / hidden info without label wrapper */
  inline?: boolean;
  /** If true, shows only the info icon when price is hidden */
  iconOnly?: boolean;
  /** Side where hovercard popup appears */
  side?: "top" | "bottom" | "left" | "right";
  /** Alignment of hovercard popup */
  align?: "start" | "center" | "end";
}
export const CoursePrice = t0 => {
  const $ = _c(39);
  const {
    price,
    currency,
    isPriceHidden,
    serviceFlags,
    label: t1,
    hiddenPriceText: t2,
    infoText: t3,
    infoTitle: t4,
    onEnquire,
    className,
    labelClassName,
    priceClassName,
    inline: t5,
    iconOnly: t6,
    side: t7,
    align: t8
  } = t0;
  const label = t1 === undefined ? "Course Fee" : t1;
  const hiddenPriceText = t2 === undefined ? "Price on Request" : t2;
  const infoText = t3 === undefined ? "This course is not available for direct enrolment. You can enquire for this price and dates." : t3;
  const infoTitle = t4 === undefined ? "Direct Enrolment Unavailable" : t4;
  const inline = t5 === undefined ? false : t5;
  const iconOnly = t6 === undefined ? false : t6;
  const side = t7 === undefined ? "top" : t7;
  const align = t8 === undefined ? "end" : t8;
  const isHidden = Boolean(isPriceHidden ?? (serviceFlags?.includes("HIDE_PRICE_ON_WEBSITE") || false));
  if (isHidden) {
    let t9;
    if ($[0] !== align || $[1] !== hiddenPriceText || $[2] !== iconOnly || $[3] !== infoText || $[4] !== infoTitle || $[5] !== onEnquire || $[6] !== side) {
      t9 = <HiddenPriceInfo text={hiddenPriceText} title={infoTitle} message={infoText} onEnquire={onEnquire} iconOnly={iconOnly} side={side} align={align} />;
      $[0] = align;
      $[1] = hiddenPriceText;
      $[2] = iconOnly;
      $[3] = infoText;
      $[4] = infoTitle;
      $[5] = onEnquire;
      $[6] = side;
      $[7] = t9;
    } else {
      t9 = $[7];
    }
    const hiddenNode = t9;
    if (inline) {
      return hiddenNode;
    }
    let t10;
    if ($[8] !== className) {
      t10 = cn("mb-4 flex items-center justify-between pt-1", className);
      $[8] = className;
      $[9] = t10;
    } else {
      t10 = $[9];
    }
    let t11;
    if ($[10] !== label || $[11] !== labelClassName) {
      t11 = label && <span className={cn("text-[10px] font-bold tracking-wider uppercase text-muted-foreground", labelClassName)}>{label}</span>;
      $[10] = label;
      $[11] = labelClassName;
      $[12] = t11;
    } else {
      t11 = $[12];
    }
    let t12;
    if ($[13] !== hiddenNode || $[14] !== t10 || $[15] !== t11) {
      t12 = <div className={t10}>{t11}{hiddenNode}</div>;
      $[13] = hiddenNode;
      $[14] = t10;
      $[15] = t11;
      $[16] = t12;
    } else {
      t12 = $[16];
    }
    return t12;
  }
  if (!price || !currency) {
    return null;
  }
  let t9;
  if ($[17] !== currency || $[18] !== price) {
    t9 = formatCurrency(price, currency);
    $[17] = currency;
    $[18] = price;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const formattedPrice = t9;
  if (inline) {
    let t10;
    if ($[20] !== priceClassName) {
      t10 = cn("text-lg font-black tracking-tight text-emerald-700 dark:text-emerald-400", priceClassName);
      $[20] = priceClassName;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    let t11;
    if ($[22] !== formattedPrice || $[23] !== t10) {
      t11 = <span className={t10}>{formattedPrice}</span>;
      $[22] = formattedPrice;
      $[23] = t10;
      $[24] = t11;
    } else {
      t11 = $[24];
    }
    return t11;
  }
  let t10;
  if ($[25] !== className) {
    t10 = cn("mb-4 flex items-center justify-between pt-1", className);
    $[25] = className;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== label || $[28] !== labelClassName) {
    t11 = label && <span className={cn("text-[10px] font-bold tracking-wider uppercase text-muted-foreground", labelClassName)}>{label}</span>;
    $[27] = label;
    $[28] = labelClassName;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== priceClassName) {
    t12 = cn("text-lg font-black leading-none tracking-tight text-emerald-700 dark:text-emerald-400", priceClassName);
    $[30] = priceClassName;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== formattedPrice || $[33] !== t12) {
    t13 = <span className={t12}>{formattedPrice}</span>;
    $[32] = formattedPrice;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t10 || $[36] !== t11 || $[37] !== t13) {
    t14 = <div className={t10}>{t11}{t13}</div>;
    $[35] = t10;
    $[36] = t11;
    $[37] = t13;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  return t14;
};